import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import  Layout  from  '@/views/layout/Layout' 
/* Router Modules */

import baseRouter from './modules/base'   
import userRouter from './modules/user'   
import doorRouter from './modules/door'  
import liftRouter from './modules/lift'  
import talkbackRouter from './modules/talkback'   
import workRouter from './modules/work'   
import reportRouter from './modules/report'  
import visitorRouter from './modules/visitor'  
import monitorRouter from './modules/monitor'  
import cardRouter from './modules/card'  

export const routers = [
    {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path*',
        component: () => import('@/views/redirect/index')
      }
    ]
  },
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  {
    path: '/404',
    component: () => import('@/views/errorPage/404'),
    hidden: true
  },
  {
    path: '/401',
    component: () => import('@/views/errorPage/401'),
    hidden: true
  },
  {
    path: '/forbidden',
    component: () => import('@/views/errorPage/forbidden'),
    hidden: true
  },
  {
    path: '/monitor',
    component: () => import('@/views/monitor/index'),
    hidden: true
  }, 
  {
    path: '',
    component: Layout,
    redirect: '/login',
    children: [
      {
        path: 'index',
        component: () => import('@/views/index/index'),
        name: 'Index',
        meta: { title: 'index', icon: 'dashboard', noCache: true }
      }
    ]
  }
] 
routers.push(baseRouter);
routers.push(userRouter);  
routers.push(reportRouter);   
routers.push(doorRouter);
routers.push(liftRouter);  
routers.push(talkbackRouter);  
routers.push(workRouter);   
routers.push(monitorRouter);   
routers.push(cardRouter);  
routers.push(visitorRouter);  

export default new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: routers
})



// WEBPACK FOOTER //
// ./src/router/index.js